var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton-wrapper',{staticClass:"my-2",attrs:{"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('b-skeleton-img',{attrs:{"no-aspect":"","height":_vm.options.chart.height + 'px'}})]},proxy:true}])},[_c('apexchart',{attrs:{"height":_vm.options.chart.height,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }